export const LanguageConstants = {
  ACCOUNT_CREATE_LABELS: 'accountCreateLabels',
  ACCOUNT_VIEW_LABELS: 'accountViewLabels',
  BILLING_SHEET_LABELS: 'billingSheetLabels',
  BILLING_SHEET_PDF_LABELS: 'billingSheetPdfLabels',
  CARRIER_CREATE: 'carrierCreateLabels',
  CARRIER_VIEW: 'carrierViewLabels',
  COST_REVIEW_LABELS: 'costReviewLabels',
  COST_STATUS_LABELS: 'costStatusLabels',
  DETAIL_STOP_LABELS: 'detailStopLabels',
  DIALOG_FILES_DETAIL_LABELS: 'dialogFilesDetailLabels',
  DIALOG_FILE_PREVIEW: 'dialogFilePreviewTags',
  DIALOG_ORDER_DETAIL_LABELS: 'dialogOrderDetailLabels',
  DIALOG_PASSWORD_LABELS: 'dialogPasswordLabels',
  DIALOG_SCANNED_GUIDES_LABELS: 'dialogScannedGuidesLabels',
  DIALOG_TRANSPORT_ASSIGNMENT_LABELS: 'dialogTransportAssignmentLabels',
  DIALOG_VALIDATE_EVIDENCE_LABELS: 'DialogValidateEvidenceLabels',
  DOWNLOAD_FILES_SERVICE_LABELS: 'downloadFilesServiceLabels',
  DRAG_AND_DROP_LABELS: 'dragAndDropLabels',
  DRIVERAPPSTATUS: 'driverAppStatus',
  DRIVER_CREATE_LABELS: 'driverCreateLabels',
  DRIVER_VIEW_LABELS: 'driverViewLabels',
  DYNAMIC_LOCATION_MAP: 'dynamicLocationMapLabels',
  EVIDENCE_DOWNLOAD_LABELS: 'evidenceDownloadLabels',
  EVIDENCE_FOLIO_FORMAT_LABEL: 'evidencenceFolioFormatViewLabel',
  EVIDENCE_INFO_LABELS: 'evidenceInfoLabels',
  EVIDENCE_MASSIVE_LOAD: 'evidenceMassiveLoad',
  EVIDENCE_RELEASE_FOLIO_DOCUMENT_LABEL: 'evidenceReleaseFolioDocumentLabel',
  EVIDENCE_RELEASE_LABELS: 'evidenceReleaseLabels',
  EVIDENCE_STATUS_LABELS: 'evidenceStatusLabels',
  FILTER_MENU_TYPES: 'filterMenuTypesLabels',
  FILTER_MENU_TYPES_STATUS: 'filterMenuTypesStatus',
  FILTER_MENU_TYPES_SEARCH: 'filterMenuTypes',
  GENERIC_TAGS: 'genericTags',
  GENERIC_INCIDENCE: 'genericIncidenceTags',
  GOODS_RECEIPT_LABELS: 'goodsReceiptLabels',
  IMPORT_SHIPMENTS_LABELS: 'importShipmentsLabels',
  ITEMS_LIST_LABELS: 'itemsListLabels',
  JOURNEY_MENU: 'journeyMenuLabels',
  JOURNEY_MENU_ITEM_COMPONENT: 'journeyMenuComponentItemLabels',
  LANGUAGE_LABELS: 'languageLabels',
  LIVE_TRACKING_BAR_LABELS: 'liveTrackingBarLabels',
  LIVE_TRACKING_FILTER_LABELS: 'liveTrackingFilterLabels',
  LIVE_TRACKING_LABELS: 'liveTrackingLabels',
  LOCATION_CREATE_LABELS: 'locationCreateLabels',
  LOCATION_CREATE_TAGS: 'locationCreateTags',
  LOCATION_VIEW_LABELS: 'locationViewLabels',
  LOGIN_LABELS: 'loginLabels',
  MAP_LABELS: 'mapTrackingLabels',
  MANUAL_DELIVERY_DETAIL_LABELS: 'manualDeliveryDetailLabels',
  MANUAL_DELIVERY_INFO_STATUS_CATALOG: 'manualDeliveryInformationStatus',
  MANUAL_DELIVERY_LABELS: 'manualDeliveryLabels',
  MENU_LABELS: 'menuLabels',
  GUIDE_HISTORY_TAGS: 'guideHistoryTags',
  MANUAL_DELIVERY_REJECTION_RESPONSIBLE: 'manualDeliveryRejectionResponsible',
  MANUAL_DELIVERY_REJECTION_RESPONSIBLE_LABELS: 'manualDeliveryRejectionResponsibleLabels',
  MANUAL_DELIVERY_STATUS_CATALOG: 'manualDeliveryStatusCatalog',
  MINI_CAROUSEL: 'miniCarouselTags',
  MULTIPLE_INPUT_SEARCH_LABELS: 'multipleInputSearchLabels',
  ORDER_CREATE: 'orderCreateLabels',
  ORDER_HISTORY_LITE_LABELS: 'orderHistoryLiteLabels',
  ORDER_HISTORY_LITE_STATUS: 'orderHistoryLiteShipmentStatus',
  ORDER_HISTORY_LITE_TAGS: 'orderHistoryLiteTags',
  ORDER_MASSIVE_LOAD_LABELS: 'orderMassiveLoadLabels',
  ORDER_REMOVE_LABELS: 'orderRemoveDialogLabels',
  ORDER_SEARCH_TYPES_LABELS: 'orderSearchTypesLabels',
  ORDER_SCANNED_STATUS_LABELS: 'orderScannedStatusLabels',
  ORDER_STATUS_CATALOG: 'orderStatusCatalog',
  ORDER_STATUS_LABELS: 'orderStatusLabels',
  ORDER_VIEW: 'viewOrderLabels',
  PDF_LABELS: 'pdfLabels',
  PROOF_OF_DELIVERY_LABELS: 'ProofOfDeliveryLabels',
  PRODUCT_SKU_VIEW_LABELS: 'productSkuViewLabels',
  RECEIVER_LOCATION_LABELS: 'receiverLocationLabels',
  REVERT_FAILED_STAMP_LABELS: 'revertFailedStampLabels',
  REVERT_SHIPMENT_LABELS: 'revertShipmentLabels',
  ROADNET_SERVICE_LABELS: 'roadnetServiceLabels',
  ROLE_CREATE_LABELS: 'roleCreateLabels',
  ROLE_VIEW_LABELS: 'roleViewLabels',
  SELECT_SEARCH: 'selectSearch',
  SHIPMENT_CREATION_LABELS: 'shipmentCreationLabels',
  SHIPMENT_DETAIL_INFO_LABELS: 'shipmentDetailInfoLabels',
  SHIPMENT_DETAIL_INFO_STATUS: 'shipmentDetailInfoStatus',
  SHIPMENT_GRID: 'shipmentGridLabels',
  SHIPMENT_INFO_LABELS: 'shipmentInfoLabels',
  SHIPMENT_INFO_STATUS: 'shipmentInfoStatus',
  SHIPMENT_REQUEST_STATUS_LABELS: 'shipmentRequestStatusLabels',
  SHIPMENT_STATUS_CATALOG: 'shipmentStatusCatalog',
  SHIPMENT_TEMPERATURE_LABELS: 'shipmentTemperatureLabels',
  SHIPMENT_VIEW: 'shipmentViewLabels',
  SPECIFIC_DELIVERY_SUMMARY_LABELS: 'specificDeliverySummaryLabels',
  STOP_LIST: 'stopListLabels',
  STOP_LIST_TRANSLATED: 'stopStatusCatalogTranslated',
  STOP_STATUS: 'stopStatusCatalog',
  TOASTR_ALERTS_SERVICE_LABELS: 'toastrAlertsServiceLabels',
  TRACKING_LABELS: 'trackingLabels',
  USER_CREATE_LABELS: 'userCreateLabels',
  USER_VIEW_LABELS: 'userViewLabels',
  VALIDATE_EVIDENCE_PDF_LABELS: 'ValidateEvidencePdfLabels',
  VEHICLE_ACCESS_CONTROL: 'vehicleAccessControlText',
  VEHICLE_CONTROL_TAGS: 'vehicleControlTags',
  VEHICLE_CREATE_LABELS: 'vehicleCreateLabels',
  VEHICLE_TYPE_CREATE: 'vehicleTypeCreateLabels',
  VEHICLE_TYPE_VIEW: 'vehicleTypeViewLabels',
  VEHICLE_VIEW_LABELS: 'vehicleViewLabels',
  WAREHOUSE_CREATE: 'warehouseCreateLocationLabels',
  WAREHOUSE_VIEW: 'warehouseViewLabels'
};
